module.exports = __webpack_public_path__ + "img/compentation_gift.7cf9f1cd.svg";